export default __webpack_public_path__ + "static/media/V450_G_BD.be3c1ea2.pdf";